import {useEffect} from "react";
import {
	Col,
	ColorPicker,
	Form,
	Input,
	InputNumber,
	Modal,
	Row,
	Slider,
	Space,
	Switch,
	Typography
} from "antd";

const {Text} = Typography;

function QualitySlider({value, onChange, globalQuality})
{
	return (
		<Row gutter={16} align="middle">
			<Col flex="auto">
				<Slider
					min={1}
					max={100}
					value={value}
					onChange={onChange}
					marks={{
						1: "Min",
						[globalQuality || 80]: "Global",
						100: "Max"
					}}
					tooltip={{formatter: (v) => `${v}%`}}
				/>
			</Col>
			<Col>
				<InputNumber
					min={1}
					max={100}
					style={{width: 70}}
					controls={false}
					value={value}
					onChange={onChange}
				/>
			</Col>
		</Row>
	);
}

export default function WebpProfileModal({open, profile, onSave, onCancel, globalQuality})
{
	const [form] = Form.useForm();
	const isEdit = !!profile;

	const canvasEnabled = Form.useWatch(["canvas", "enabled"], form);
	const transparency = Form.useWatch("transparency", form);

	useEffect(() =>
	{
		if (open)
		{
			if (profile)
			{
				form.setFieldsValue({
					name: profile.name,
					canvas: {
						enabled: profile.canvas?.enabled || false,
						width: profile.canvas?.width || 1024,
						height: profile.canvas?.height || 1024,
						fillPercentage: profile.canvas?.fillPercentage || 100
					},
					transparency: profile.transparency !== false,
					backgroundColor: profile.backgroundColor || "#FFFFFF",
					quality: profile.quality || globalQuality || 80,
					isDefault: profile.isDefault || false
				});
			}
			else
			{
				form.setFieldsValue({
					name: "",
					canvas: {
						enabled: false,
						width: 1024,
						height: 1024,
						fillPercentage: 100
					},
					transparency: true,
					backgroundColor: "#FFFFFF",
					quality: globalQuality || 80,
					isDefault: false
				});
			}
		}
	}, [open, profile, form, globalQuality]);

	const handleOk = async () =>
	{
		try
		{
			const values = await form.validateFields();
			onSave({
				...values,
				id: profile?.id
			});
			form.resetFields();
		}
		catch (error)
		{
			console.error("Validation error:", error);
		}
	};

	const handleCancel = () =>
	{
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title={isEdit ? "Modifica impostazione" : "Aggiungi impostazione"}
			open={open}
			onOk={handleOk}
			onCancel={handleCancel}
			width={700}
			okText={isEdit ? "Salva" : "Aggiungi"}
			cancelText="Annulla"
		>
			<Form
				form={form}
				layout="vertical"
				style={{marginTop: 24}}
			>
				<Form.Item
					label="Nome impostazione"
					name="name"
					rules={[{required: true, message: "Inserisci un nome"}]}
				>
					<Input placeholder="es. Volantino NATIVA HD" />
				</Form.Item>

				<Form.Item
					label="Canvas di sfondo"
					name={["canvas", "enabled"]}
					valuePropName="checked"
				>
					<Switch checkedChildren="Attivo" unCheckedChildren="Disattivo" />
				</Form.Item>

				{canvasEnabled && (
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item
								label="Larghezza canvas (px)"
								name={["canvas", "width"]}
								rules={[{required: true, message: "Richiesto"}]}
							>
								<InputNumber
									min={1}
									max={20000}
									style={{width: "100%"}}
									placeholder="1024"
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								label="Altezza canvas (px)"
								name={["canvas", "height"]}
								rules={[{required: true, message: "Richiesto"}]}
							>
								<InputNumber
									min={1}
									max={20000}
									style={{width: "100%"}}
									placeholder="1024"
								/>
							</Form.Item>
						</Col>
					</Row>
				)}

				{canvasEnabled && (
					<Form.Item
						label="Riempimento immagine nel canvas (%)"
						name={["canvas", "fillPercentage"]}
						extra="100% riempie completamente il lato dominante del canvas; valori inferiori mantengono un margine interno."
						rules={[{required: true, message: "Richiesto"}]}
					>
						<InputNumber
							min={1}
							max={100}
							step={1}
							style={{width: "100%"}}
							placeholder="100"
						/>
					</Form.Item>
				)}

				<Form.Item
					label="Trasparenza"
					name="transparency"
					valuePropName="checked"
				>
					<Switch checkedChildren="Attiva" unCheckedChildren="Disattiva" />
				</Form.Item>

				{!transparency && (
					<Form.Item
						label="Colore di sfondo"
						name="backgroundColor"
						getValueFromEvent={(color) => color.toHexString()}
					>
						<ColorPicker
							showText
							format="hex"
							style={{width: "100%"}}
						/>
					</Form.Item>
				)}

				<Form.Item
					label={
						<Space>
							<span>Qualità esportazione</span>
							<Text type="secondary" style={{fontSize: 12}}>
								(eredita: {globalQuality || 80})
							</Text>
						</Space>
					}
					name="quality"
				>
					<QualitySlider globalQuality={globalQuality} />
				</Form.Item>

				<Form.Item
					label="Imposta come default"
					name="isDefault"
					valuePropName="checked"
				>
					<Switch checkedChildren="Default" unCheckedChildren="Default" />
				</Form.Item>
			</Form>
		</Modal>
	);
}
